<template>
  <section class="form__item__input">
    <color-picker :id="id" v-model="value" :defaultValue="value"></color-picker>
  </section>
</template>

<script>
import { Chrome } from 'vue-color'

export default {
  name: 'ColorPickerInput',
  components: {
    'color-picker': Chrome
  },
  methods: {
    update(value){
      this.$emit('input', value);
    }
  },
  props: ['defaultValue', 'id'],
  data(){
    return {
      value: this.defaultValue || '#194d33'
    }
  },
  watch: {
    value(newVal){
      console.log('newVal', newVal);
      this.update(newVal.hex);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/configurator/ColorPickerInput.vue